 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import SS_US_ADULT_SIGNUP_FRONT from '@/components/SS_US_adult_signup_front'
 import LOVE_1 from '@/components/love_1'
 import TITLE from '@/components/title'
 import CONTENTS from '@/components/contents'
 import DED from '@/components/ded'
 import EPI from '@/components/epi'
 import HALF from '@/components/half'
 import PRO from '@/components/pro'
 import CH01 from '@/components/ch01'
 import CH02 from '@/components/ch02'
 import CH03 from '@/components/ch03'
 import CH04 from '@/components/ch04'
 import CH05 from '@/components/ch05'
 import CH06 from '@/components/ch06'
 import CH07 from '@/components/ch07'
 import CH08 from '@/components/ch08'
 import NOTE from '@/components/note'
 import ACK from '@/components/ack'
 import SS_RECOMMENDPAGE from '@/components/SS_recommendpage'
 import ABOUT from '@/components/about'
 import ALSO from '@/components/also'
 import INDEX from '@/components/index'
 import LOVE_2 from '@/components/love_2'
 import SS_US_ADULT_SIGNUP_BACK from '@/components/SS_US_adult_signup_back'
 import COPYRIGHT from '@/components/copyright'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/contents",
 			"name" : "contents",
 			"component" : CONTENTS
 		},
 		{
 			"path" : "/ded",
 			"name" : "ded",
 			"component" : DED
 		},
 		{
 			"path" : "/epi",
 			"name" : "epi",
 			"component" : EPI
 		},
 		{
 			"path" : "/half",
 			"name" : "half",
 			"component" : HALF
 		},
 		{
 			"path" : "/pro",
 			"name" : "pro",
 			"component" : PRO
 		},
 		{
 			"path" : "/ch01",
 			"name" : "ch01",
 			"component" : CH01
 		},
 		{
 			"path" : "/ch02",
 			"name" : "ch02",
 			"component" : CH02
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js